module.exports = __webpack_public_path__ + "img/Contacts.e1cf29bf.svg";